import { Route } from 'react-router-dom';
import { home } from 'routes/config';

import ChatLogs from '@/pages/Business/Agent/ChatLogs';
import CallLogForm from '@/pages/Business/Agent/CallLogs/components/CallLogForm';

export const chatLogsRoutes = (
  <Route path={home.chatLogs} element={<ChatLogs />}>
    <Route path=':id' element={<CallLogForm />} />
  </Route>
);
